import { formatPropertyLocation } from '~/components/Offers/Detail/OfferBuilder/Content/PropertyInformation';

import { type BuildDetailsFieldsParams, field, selectField, typedField, withLayout } from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildPropertyInfoFields({ opportunity, property }: BuildDetailsFieldsParams): Array<DetailField> {
  const partnershipGoals = opportunity?.partnership_goals;
  const keyCommercial = opportunity?.key_commercial;
  const productAndSoloTraveller = opportunity?.product_and_solo_traveller;
  const hotelPropertyInfo = opportunity?.hotel_property_info;

  return [
    withLayout(
      field(
        'USP',
        partnershipGoals?.usp__c,
        'Sell us the deal! What is the core USP? Give us MORE detail not less.',
        true,
      ),
      { columns: 1 },
    ),
    withLayout(
      field(
        '#1 Selling Point',
        hotelPropertyInfo?.x1_selling_point__c,
        'What is the single most unique selling point and why?',
        true,
      ),
      { columns: 2 },
    ),
    withLayout(
      field(
        'Customer Experience Notes',
        hotelPropertyInfo?.customer_experience_notes__c,
        'Customer experience notes for the property.',
        true,
      ),
      {
        columns: 2,
      },
    ),
    selectField(
      'Holiday Vibe',
      hotelPropertyInfo?.holiday_vibe__c,
      [
        'CBD Staycation',
        'Beach Getaway',
        'Mountain Retreat',
        '5-star luxury',
        'Stylish stopover',
        'Unique experience',
        'Romantic',
        'Family fun',
        'Foodie',
      ],
      'What is the holiday vibe?',
      { columns: 2 },
    ),
    selectField(
      'Target Selling Market',
      hotelPropertyInfo?.target_selling_market__c,
      ['Couples', 'Families', 'Solo Travelers', 'Groups', 'Other'],
      'Who is this campaign targeting?',
      {
        columns: 2,
      },
    ),
    withLayout(field('Check-in/out time', hotelPropertyInfo?.check_in_out_time__c, 'Check-in and check-out times'), {
      columns: 2,
    }),
    withLayout(field('Hotel Age', hotelPropertyInfo?.hotel_age__c, 'Year the hotel opened'), { columns: 2 }),
    withLayout(field('Hotel Last Renovation', hotelPropertyInfo?.hotel_last_renovation__c, 'Year of last renovation'), {
      columns: 2,
    }),
    withLayout(field('Closest Airport', hotelPropertyInfo?.closest_airport__c, 'Closest major airport'), {
      columns: 2,
    }),
    withLayout(
      field('Airport Transfer Cost', hotelPropertyInfo?.airport_transfer_cost__c, 'Approximate transfer cost'),
      { columns: 2 },
    ),
    withLayout(
      field('Distance to the Beach', hotelPropertyInfo?.distance_to_the_beach__c, 'Distance to nearest beach'),
      { columns: 2 },
    ),
    withLayout(field('Location Attractions', formatPropertyLocation(property), 'Nearby attractions', true), {
      columns: 2,
    }),
    withLayout(
      field(
        'Other Key Benefits',
        hotelPropertyInfo?.other_key_benefits__c,
        'List any other key benefits or amenities.',
        true,
      ),
      {
        columns: 2,
      },
    ),
    withLayout(field('Disability Access', hotelPropertyInfo?.disability_access__c, 'Disability access info'), {
      columns: 2,
    }),
    withLayout(
      field(
        'Rooms with Wheelchair access',
        hotelPropertyInfo?.rooms_with_wheelchair_access__c,
        'Number of wheelchair-accessible rooms',
      ),
      {
        columns: 2,
      },
    ),
    withLayout(field('Smoking Policy', hotelPropertyInfo?.smoking_policy__c, 'Property smoking policy'), {
      columns: 2,
    }),
    withLayout(field('Parking', hotelPropertyInfo?.parking__c, 'Parking availability and cost'), { columns: 2 }),
    withLayout(field('Wi-fi', hotelPropertyInfo?.wi_fi__c, 'Wi-fi availability'), { columns: 2 }),
    withLayout(field('Recent Awards/Accolades', hotelPropertyInfo?.recent_awards_accolades__c), { columns: 2 }),
    withLayout(field('Babysitting', hotelPropertyInfo?.babysitting__c, 'Babysitting services'), { columns: 2 }),
    withLayout(field('Kids Club', hotelPropertyInfo?.kids_club__c, 'Kids club availability'), { columns: 2 }),
    withLayout(field('Shop Onsite', hotelPropertyInfo?.shop_onsite__c, 'On-site shops'), { columns: 2 }),
    withLayout(
      field(
        'Shops and restaurants Nearby',
        hotelPropertyInfo?.shops_and_restaurants_near_by__c,
        'Nearby shops and restaurants',
      ),
      { columns: 2 },
    ),
    withLayout(
      field(
        'Gala Dinner & Other Functions Policies',
        keyCommercial?.gala_dinner_other_functions_policies__c,
        'Gala Dinner & Other Functions Policies information for internal use, does not populate contract.',
        true,
      ),
      { columns: 1 },
    ),
    withLayout(
      field(
        'Deal Copy/Image Notes',
        productAndSoloTraveller?.deal_copy_notes__c,
        'Use this field for any Copy/Editorial/Image Specific Notes For Luxury Escapes - Comments Section.',
        true,
      ),
      { columns: 2 },
    ),
    typedField('Hero Shot Link', keyCommercial?.hero_shot_link__c, 'url', undefined, {
      columns: 2,
    }),
  ];
}
